/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Coach_GroupInputs */

const en_nav_coach_group = /** @type {(inputs: Nav_Coach_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coach`)
};

const es_nav_coach_group = /** @type {(inputs: Nav_Coach_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrenador`)
};

const de_nav_coach_group = /** @type {(inputs: Nav_Coach_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainer`)
};

const zh_nav_coach_group = /** @type {(inputs: Nav_Coach_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`教练`)
};

const ar_nav_coach_group = /** @type {(inputs: Nav_Coach_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المدرب`)
};

const fr_nav_coach_group = /** @type {(inputs: Nav_Coach_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entraîneur`)
};

const vi_nav_coach_group = /** @type {(inputs: Nav_Coach_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huấn luyện viên`)
};

const sw_nav_coach_group = /** @type {(inputs: Nav_Coach_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kocha`)
};

const th_nav_coach_group = /** @type {(inputs: Nav_Coach_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โค้ช`)
};

const bs_nav_coach_group = /** @type {(inputs: Nav_Coach_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trener`)
};

const ja_nav_coach_group = /** @type {(inputs: Nav_Coach_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コーチ`)
};

const ko_nav_coach_group = /** @type {(inputs: Nav_Coach_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`코치`)
};

const pt_nav_coach_group = /** @type {(inputs: Nav_Coach_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treinador`)
};

const it_nav_coach_group = /** @type {(inputs: Nav_Coach_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allenatore`)
};

const sv_nav_coach_group = /** @type {(inputs: Nav_Coach_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tränare`)
};

const nl_nav_coach_group = /** @type {(inputs: Nav_Coach_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coach`)
};

const da_nav_coach_group = /** @type {(inputs: Nav_Coach_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Træner`)
};

const nb_nav_coach_group = /** @type {(inputs: Nav_Coach_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trener`)
};

const fi_nav_coach_group = /** @type {(inputs: Nav_Coach_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valmentaja`)
};

const pl_nav_coach_group = /** @type {(inputs: Nav_Coach_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trener`)
};

const ru_nav_coach_group = /** @type {(inputs: Nav_Coach_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тренер`)
};

const tr_nav_coach_group = /** @type {(inputs: Nav_Coach_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koç`)
};

const hi_nav_coach_group = /** @type {(inputs: Nav_Coach_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोच`)
};

const id_nav_coach_group = /** @type {(inputs: Nav_Coach_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelatih`)
};

const ms_nav_coach_group = /** @type {(inputs: Nav_Coach_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jurulatih`)
};

const cs_nav_coach_group = /** @type {(inputs: Nav_Coach_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trenér`)
};

const el_nav_coach_group = /** @type {(inputs: Nav_Coach_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Προπονητής`)
};

const he_nav_coach_group = /** @type {(inputs: Nav_Coach_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מאמן`)
};

const af_nav_coach_group = /** @type {(inputs: Nav_Coach_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrigter`)
};

const hu_nav_coach_group = /** @type {(inputs: Nav_Coach_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edző`)
};

/**
* | output |
* | --- |
* | "Coach" |
*
* @param {Nav_Coach_GroupInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_coach_group = /** @type {((inputs?: Nav_Coach_GroupInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Coach_GroupInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_coach_group(inputs)
	if (locale === "de") return de_nav_coach_group(inputs)
	if (locale === "zh") return zh_nav_coach_group(inputs)
	if (locale === "ar") return ar_nav_coach_group(inputs)
	if (locale === "fr") return fr_nav_coach_group(inputs)
	if (locale === "vi") return vi_nav_coach_group(inputs)
	if (locale === "sw") return sw_nav_coach_group(inputs)
	if (locale === "th") return th_nav_coach_group(inputs)
	if (locale === "bs") return bs_nav_coach_group(inputs)
	if (locale === "ja") return ja_nav_coach_group(inputs)
	if (locale === "ko") return ko_nav_coach_group(inputs)
	if (locale === "pt") return pt_nav_coach_group(inputs)
	if (locale === "it") return it_nav_coach_group(inputs)
	if (locale === "sv") return sv_nav_coach_group(inputs)
	if (locale === "nl") return nl_nav_coach_group(inputs)
	if (locale === "da") return da_nav_coach_group(inputs)
	if (locale === "nb") return nb_nav_coach_group(inputs)
	if (locale === "fi") return fi_nav_coach_group(inputs)
	if (locale === "pl") return pl_nav_coach_group(inputs)
	if (locale === "ru") return ru_nav_coach_group(inputs)
	if (locale === "tr") return tr_nav_coach_group(inputs)
	if (locale === "hi") return hi_nav_coach_group(inputs)
	if (locale === "id") return id_nav_coach_group(inputs)
	if (locale === "ms") return ms_nav_coach_group(inputs)
	if (locale === "cs") return cs_nav_coach_group(inputs)
	if (locale === "el") return el_nav_coach_group(inputs)
	if (locale === "he") return he_nav_coach_group(inputs)
	if (locale === "af") return af_nav_coach_group(inputs)
	if (locale === "hu") return hu_nav_coach_group(inputs)
	return en_nav_coach_group(inputs)
});